import { Breadcrumb, Button, message, Table, Tooltip, Typography } from "antd";
import classes from "./AppDashboard.module.scss";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createAsanaTask,
  fetchAsanaWorkspaceProjects,
  fetchAsanaWorkspaces,
} from "../../services/asana";
import { queryKeys } from "../../constants";
import Loader from "../../components/Loading";
import { getThemeColor } from "../../helpers";
import { FundViewOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import CreateTaskModal from "./CreateTask";
import asana from "../../assets/images/integration/asana.png";

const { Title , Text} = Typography;

const AsanaDashboard = () => {
  const workspaceColumns = [
    {
      title: "Workspace Id",
      dataIndex: "gid",
      key: "gid",
    },
    {
      title: "Workspace Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      key: "action",
      render: (record) => (
        <Tooltip title="View Workspace">
          <FundViewOutlined
            style={{ color: getThemeColor(), cursor: "pointer" }}
            onClick={() => handleSelectWorkspace(record)}
          />
        </Tooltip>
      ),
    },
  ];
  const projectColumns = [
    {
      title: "Project Id",
      dataIndex: "gid",
      key: "gid",
    },
    {
      title: "Project Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      key: "action",
      render: (record) => (
        <Button onClick={() => handleModalOpen(record)} size="small">
          Create Task
        </Button>
      ),
    },
  ];

  const [columns, setColumns] = useState(workspaceColumns);
  const [dataSource, setDataSource] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = (project) => {
    setIsModalOpen(true);
    setSelectedProject(project);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  const getAsanaWorkspacesQuery = useQuery({
    queryKey: [queryKeys.asanaWorkspaces],
    queryFn: () => fetchAsanaWorkspaces(),
    onError: (error) => {
      message.error(`Error: ${error.message}`);
    },
  });

  const getAsanaProjectsQuery = useMutation({
    mutationFn: fetchAsanaWorkspaceProjects,
    onSuccess: () => {
      message.success("Projects fetched successfully");
      setIsLoading(false);
    },
    onError: (error) => {
      message.error(`Error: Something went wrong`);
      setIsLoading(false);
    },
  });

  const createTaskMutation = useMutation({
    mutationFn: createAsanaTask,
    onSuccess: () => {
      handleModalClose();
      message.success("Task created successfully");
    },
    onError: (error) => {
      handleModalClose();
      message.error(`Error: Something went wrong`);
    },
  });

  const handleSelectWorkspace = (workspace) => {
    setIsLoading(true);
    getAsanaProjectsQuery.mutateAsync(workspace.gid).then((res) => {
      setSelectedWorkspace(workspace);
      setColumns(projectColumns);
      setDataSource(res.data);
      setBreadcrumbItems([
        {
          title: (
            <span className={classes.workspaceBreadcrumb}>Workspaces List</span>
          ),
          onClick: () => {
            setSelectedWorkspace(null);
            setColumns(workspaceColumns);
            setDataSource(getAsanaWorkspacesQuery?.data?.data);
          },
        },
        {
          title: workspace.name,
        },
      ]);
    });
  };

  const createTask = (taskName) => {
    createTaskMutation.mutateAsync({
      workspaceId: selectedWorkspace.gid,
      projectId: selectedProject.gid,
      data: { task_name: taskName },
    });
  };

  useEffect(() => {
    if (getAsanaWorkspacesQuery?.data?.data) {
      setDataSource(getAsanaWorkspacesQuery?.data?.data);
    }
  }, [getAsanaWorkspacesQuery?.data?.data]);

  return getAsanaWorkspacesQuery.isLoading || isLoading ? (
    <Loader />
  ) : (
    <>
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Asana App Dashboard
        </Title>

        <div className={classes.headingContainer}>
          <span className={classes.heading}>Workspaces List</span>
          <Text type="secondary" style={{ fontSize: 12 }}>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s. Lorem Ipsum is simply dummy text of the
            printing and typesetting industry. Lorem Ipsum has been the
            industry's standard dummy text ever since the 1500s.
          </Text>
        </div>

        {selectedWorkspace && (
          <div className={classes.breadcrumb}>
            <Breadcrumb items={breadcrumbItems} separator=">" />
          </div>
        )}

        <Table
          columns={columns}
          dataSource={dataSource || []}
          rowKey="id"
          size="small"
        />
      </div>
      <CreateTaskModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        selectedWorkspace={{
          ...selectedWorkspace,
          image: asana,
          description:
            "lorem ipsum dolor sit amet lorem ipsum dolor sit amet lorem ipsum dolor sit amet lorem ipsum dolor sit amet",
        }}
        selectedProject={selectedProject}
        createTask={createTask}
      />
    </>
  );
};

export default AsanaDashboard;
